import React, { useState } from "react";
import { Chart } from "react-google-charts";
// import "./DynamicPieChart.css"; // Import your CSS file
import "../OneComponent.css";
// import "../../Components/OneComponent.css";

export default function DynamicPieChart({
  dataList,
  labelField,
  chartTitle = "Question Composition",
  width = "800px",
  height = "600px",
  onSliceSelect,
  colorPalette = [
    "#d22e2e",
    "#87ceeb",
    "#34A853",
    "#836FFF",
    "#ffb347",
    "#f7cac9",
    "#b19cd9",
    "#8fbc8f",
  ],
}) {
  const [selectedSlice, setSelectedSlice] = useState(null);

  if (!Array.isArray(dataList) || dataList.length === 0)
    return <div>No data to display</div>;

  const measureFields = Object.keys(dataList[0]).filter(
    (key) => key !== labelField && typeof dataList[0][key] !== "object"
  );

  const valueField = measureFields.find(
    (key) => !isNaN(Number(dataList[0][key]))
  );
  if (!valueField) return <div>No numeric field found for pie values.</div>;

  const chartData = [
    ["Label", "Value"],
    ...dataList.map((item) => [item[labelField], Number(item[valueField])]),
  ];

  const slices = {};
  for (let i = 0; i < dataList.length; i++) {
    slices[i] = {
      color: colorPalette[i % colorPalette.length],
      offset: selectedSlice === i ? 0.2 : 0,
    };
  }

  const options = {
    // Remove the title from Google Charts options
    is3D: true,
    tooltip: { trigger: "none" },
    backgroundColor: "transparent",
    slices,
    legend: {
      textStyle: {
        fontSize: 14,
      },
    },
    chartArea: {
      width: "100%",
      height: "100%", // More space since no built-in title
      top: 20,
      left: "10%",
    },
  };

  return (
    <div className="chart-container">
      <h2 className="chart-title">{chartTitle}</h2>
      <Chart
        chartType="PieChart"
        width={width}
        height={height}
        data={chartData}
        options={options}
        chartEvents={[
          {
            eventName: "select",
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart();
              const selection = chart.getSelection();
              if (selection.length > 0) {
                const selectedIndex = selection[0].row;
                setSelectedSlice((prev) =>
                  prev === selectedIndex ? null : selectedIndex
                );

                if (onSliceSelect) {
                  const selectedData =
                    selectedIndex !== null ? dataList[selectedIndex] : null;
                  onSliceSelect(selectedData);
                }
              }
            },
          },
        ]}
      />
    </div>
  );
}
